/* @flow */

import {unexpectedCase} from 'nutshell-core/reducer-utils';
import {analyticsClient} from '../../analytics-client';

import {ActionTypes, type TrialAction} from './trial-actions';

export type TrialState = {
    isModalOpen: boolean,
};

const defaultTrialState = {
    isModalOpen: false,
};

export const trialReducer = (
    state: TrialState = defaultTrialState,
    action: TrialAction
): TrialState => {
    switch (action.type) {
        case ActionTypes.TRIAL_SWAP_MODAL_TOGGLED:
            return {
                isModalOpen: action.payload,
            };
        case ActionTypes.TRIAL_PLAN_CHANGED:
            if (action.payload === 'ns-uub-trial') {
                analyticsClient.track(analyticsClient.EVENTS.TRACK_CUSTOMER_TRIAL_UPGRADE);
            }

            if (action.payload === 'ns-uud-trial') {
                analyticsClient.track(analyticsClient.EVENTS.TRACK_CUSTOMER_TRIAL_DOWNGRADE);
            }

            return Nut.ajax.post({
                data: {
                    planSku: action.payload,
                },
                url: '/setup/index/update-trial-plan-setting.json',
            });
        default:
            unexpectedCase(action.type);

            return state;
    }
};
